/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}

function enablePreorder(variant){
  $(document).find('.ProductForm .preOrderd').html('');
  var varQty = parseInt($(document).find('[data-variant_gd="'+variant+'"]').attr('data-quantity')),
      inPolicy = $(document).find('[data-variant_gd="'+variant+'"]').attr('data-inventory_policy');
  $(document).find('.ProductForm__AddToCart span:nth-child(1)').text(window.languages.productFormAddToCart);
  if(inPolicy === 'continue' && varQty <= 0 ){
    $(document).find('.ProductForm .preOrderd').html('<input type="hidden" name="properties[_preOrder]" value="Yes">');
    $(document).find('.ProductForm__AddToCart span:nth-child(1)').text(window.languages.productFormpreOrder);
  }
}

$(document).ready(function(){
  var vaded = $('#variant_loop-data').attr('data-selected_variant');
  enablePreorder(vaded);
});

document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details
  enablePreorder(variant.id);
});


$(document).ready(function(){
  var vaded = $('#variant_loop-data').attr('data-selected_variant');
  enablePreorder(vaded);
});

document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details
  enablePreorder(variant.id);
});

//var varjson = $.parseJSON($('#product_variants-call').html());
$(document).on('change','[name="option-1"]',function(){
  var parent = $(this).closest('form');
  var opt2val = $(parent).find('[name="option-1"]:checked').val();
  console.log(opt2val);
  $('#product_variants-call').find('li').each(function(i,item){
    var opt2 = $(this).attr('data-opt2'),
        opt1 = $(this).attr('data-opt1')
    // console.log(opt1);
    if(opt2 === opt2val){
      var var_inve = $(this).attr('data-variant-inventory'),
          varqty = parseInt($(this).attr('data-variant-qty'));
      
      $('.Popover__ValueList [data-option-position="1"]').each(function(){
		var optval = $(this).attr('data-value');
        //console.log(optval +'  '+opt1)
        if(optval === opt1 ){
          if(varqty == 0 && var_inve === 'continue'){
            $(this).attr('data-info','Pre order');
          }else if(varqty == 0 && var_inve !== 'continue' ){
            $(this).attr('data-info','TÜKENDİ');
          }else{
            $(this).attr('data-info','SATIN AL');
          }
          //console.log(var_inve + '  ' + varqty )
        }
      })

    }
  });
})
